import React, { useState } from 'react';
import api from '../../utils/axios';
import { useNavigate } from 'react-router-dom';

const CreateVehicle = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    plateNumber: '',
    office: '',
    type: '',
    status: 'active',
    remarks: '',
  });
  const [error, setError] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    try {
      const token = localStorage.getItem('token');
      await api.post(`/api/vehicles`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate('/vehicles');
    } catch (err) {
      console.error('Failed to create vehicle:', err);
      setError('Failed to create vehicle');
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Create New Vehicle</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Vehicle Name</label>
          <input type="text" name="name" value={form.name} onChange={handleChange} className="form-control" required />
        </div>

        <div className="mb-3">
          <label className="form-label">Plate Number</label>
          <input type="text" name="plateNumber" value={form.plateNumber} onChange={handleChange} className="form-control" required />
        </div>

        <div className="mb-3">
          <label className="form-label">Office</label>
          <select name="office" value={form.office} onChange={handleChange} className="form-select" required>
            <option value="">-- Select Office --</option>
            <option value="HQ">HQ</option>
            <option value="SITE">Site</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Type</label>
          <input type="text" name="type" value={form.type} onChange={handleChange} className="form-control" placeholder="e.g., SUV, Sedan, Truck" />
        </div>

        <div className="mb-3">
          <label className="form-label">Status</label>
          <select name="status" value={form.status} onChange={handleChange} className="form-select">
            <option value="active">Active</option>
            <option value="maintenance">Maintenance</option>
            <option value="retired">Retired</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Remarks</label>
          <textarea name="remarks" value={form.remarks} onChange={handleChange} className="form-control" />
        </div>

        <button type="submit" className="btn btn-primary">Create Vehicle</button>
      </form>
    </div>
  );
};

export default CreateVehicle;
